import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const NumberNo: BleskIcon = forwardRef(function Plus(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M16.5 17.1222H21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="16.5"
        y="6.42236"
        width="4.5"
        height="6.3"
        rx="1.53"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 17.2224V6.42236H3.9L10.2 17.2224H11.1V6.42236"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
